module.exports = __webpack_public_path__ + "static/media/tec_italy_arium_micrositio_home_elixir-300x293.d79a24df.png";